const ROOT_HANDLING_LOADING = 'ROOT_HANDLING_LOADING';
const ROOT_HANDLING_UNLOADING = 'ROOT_HANDLING_UNLOADING';
const HANDLING_LOADING = 'HANDLING_LOADING';
const HANDLING_UNLOADING = 'HANDLING_UNLOADING';

const HANDLING_EXTRAS = [HANDLING_LOADING, HANDLING_UNLOADING];

const HANDLES_BY_STOPTYPE = {
  pickup: HANDLING_LOADING,
  dropoff: HANDLING_UNLOADING,
};

const INSURANCE = 'INSURANCE';

const RECURRING_ORDER_NOT_COMMON_EXTRAS = [
  'NIGHT',
  'DAY_SATURDAY',
  'DAY_SUNDAY',
  'LOADED_FOR_TOO_LONG',
];

const RADIOS_EXTRAS = ['LIFTGATE', 'SIDE_LOAD'];
const DISCOUNT_PICKUP_AT_LOW_DEMAND_INTERVAL =
  'DISCOUNT_PICKUP_AT_LOW_DEMAND_INTERVAL';
const DISCOUNT_VOLUME = 'DISCOUNT_VOLUME';
const DISCOUNT_EXTRAS = [
  DISCOUNT_PICKUP_AT_LOW_DEMAND_INTERVAL,
  DISCOUNT_VOLUME,
];

export default {
  HANDLING_EXTRAS,
  HANDLES_BY_STOPTYPE,
  INSURANCE,
  RECURRING_ORDER_NOT_COMMON_EXTRAS,
  RADIOS_EXTRAS,
  DISCOUNT_PICKUP_AT_LOW_DEMAND_INTERVAL,
  DISCOUNT_EXTRAS,
  ROOT_HANDLING_LOADING,
  ROOT_HANDLING_UNLOADING,
  HANDLING_LOADING,
  HANDLING_UNLOADING,
};
